import { Component, Directive } from '@angular/core';

@Component({
  selector: 'uex-dropdown-header',
  template: '<h6 class="uex-dropdown-header dropdown-header"><ng-content></ng-content></h6>'
})
export class DropdownHeaderComponent { }

@Directive({
  selector: '[uex-dropdown-header]',
  host: {
    class: 'uex-dropdown-header dropdown-header'
  }
})
export class DropdownHeaderDirective { }
